function collectionMasonryVideo(){
const msnryVideos = document.querySelectorAll('.product-list .product-block');
// const msnryVideos = Shopify.collectionMasonryVideos

$(document).ready(function(){
  if (window.matchMedia("(min-width: 769px)").matches) {
    
    const msnry = new Masonry( '.product-list', { itemSelector: '.product-block' });
    
    const loadCollectionVideos = new Promise(function(resolve, reject) {
      Shopify.collectionMasonryVideos.forEach(({ index, src, thumb, title, layout }) => {
        if (msnryVideos[index-1]) {
          msnryVideos[index-1].insertAdjacentHTML("beforebegin", `
			<div class="product-block layout__${layout} one-half amber">
				<div class="block-inner msnryvideo" data-index="${index}" title="video">
                  <video class="video-background" loop="" muted="" no-controls="" autoplay="" src="${thumb}" playsinline="">
                  <source type="video/mp4" src="${thumb}">
                  </source></video>
				</div>
			</div>`);
        
          const newTile = document.querySelector(`[data-index="${index}"]`);
          const newVideo = newTile.querySelector(`video`);
        
          newTile.classList.add('loaded');
       
          newVideo.src = src;
        };
        
      });

      resolve('Collection videos loaded.');
    });
    
    loadCollectionVideos.then(result => {
		msnry.reloadItems();
      	msnry.layout();
    });
  }

    if (window.matchMedia("(max-width: 798px)").matches) {
    
    const msnry = new Masonry( '.product-list', { itemSelector: '.product-block' });
    
    const loadCollectionVideos = new Promise(function(resolve, reject) {
      Shopify.collectionMasonryVideos.forEach(({ index, src, thumb, title, layout }) => {
        if (msnryVideos[index-1]) {
          msnryVideos[index-1].insertAdjacentHTML("beforebegin", `
			<div class="product-block layout__${layout} one-half amber">
				<div class="block-inner msnryvideo" data-index="${index}" title="video">
                  <video class="video-background" loop="" muted="" no-controls="" autoplay="" src="${thumb}" playsinline="">
                  <source type="video/mp4" src="${thumb}">
                  </source></video>
				</div>
			</div>`);
        
          const newTile = document.querySelector(`[data-index="${index}"]`);
          const newVideo = newTile.querySelector(`video`);
        
          newTile.classList.add('loaded');
       
          newVideo.src = src;
        };
        
      });

      resolve('Collection videos loaded.');
    });
    
    loadCollectionVideos.then(result => {
		msnry.reloadItems();
      	msnry.layout();
    });
  }
    

$('.variant-input').click(function() {
  $(this).parent().find('.variant-input').removeClass('active')
  $(this).addClass('active') 
})

})
  
}

$(document).ready(function(){
  collectionMasonryVideo();
});